import GameService from "src/services/GameService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {
	SAVE: "game/save",
	STORE: "game/store",
	UPDATE: "game/update",
	DUPLICATE: "game/duplicate",
	DELETE: "game/delete",
};

export const params = {
	name: "",
	company_id: "",
	type_id: "",
	min_questions: 0,
	public: true,
	tags: [],
	newTags: [],
	share: true,

};

/**
@namespace
@property  {object} module,
@property  {object} module.state,
@property  {object} modules.game,
@property  {array}  modules.games
**/

const module = {
	state: {},
	mutations: {},
	getters: {},
	actions: {
		async [types.DUPLICATE] (context, duplicate) {
			const game = await GameService.duplicate(duplicate.id, duplicate);
			if (!duplicate.deleted_at) {
				context.commit(types.STORE, game);
			}
			return game;
		},
	},
	types: types,
};
export default ModuleCreator("game", GameService, module, types, params);
